// Active Tab key for Billing content (sidebar)
export const BillingTabContentActiveTab = (activeTab) => {
    return {
        type: 'BillingTabContentActiveTab',
        payload: activeTab
    }
}
// ContentList for Billing content (sidebar)
export const BillingTabList = (tabList) => {
    return {
        type: 'BillingTabList',
        payload: tabList
    }
}
// TabAction for Claimss
export const TabActionClaims = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'OPEN_TAB_CLAIM',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}
//to get Claims data
export const OpenNewClaimTabAction = (data) => {
    return {
        type: 'Open_New_Claim_Tab',
        payload: {
            data: data,
        },
    }
}


// TabAction for Payments
export const TabActionPayments = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'OPEN_TAB_PAYMENT',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}

// TabAction for Encounter
// export const TabActionEncounters = (data, id, sideNavKey, childActiveId) => {
//     return {
//         type: 'OPEN_TAB_ENCOUNTER',
//         payload: {
//             data: data,
//             id: id ? id : undefined,
//             sideNavKey: sideNavKey,
//             childActiveId: childActiveId
//         },
//     }
// }
//to get Claims data
export const OpenNewPaymentTabAction = (data) => {
    return {
        type: 'Open_New_Payment_Tab',
        payload: {
            data: data,
        },
    }
}

//to get Encounter data
// export const OpenNewEncounterTabAction = (data) => {
//     return {
//         type: 'Open_New_Encounter_Tab',
//         payload: {
//             data: data,
//         },
//     }
// }

//to get Payments data
export const PaymentsRecordAction = (Data) => {
    return {
        type: 'PaymentsRecordAction',
        payload: Data
    }
}
// to store id and name of all claims that are loaded in the grid currently
export const ClaimsRecordAction = (Data) => {
    return {
        type: 'ClaimsRecordAction',
        payload: Data
    }
}
export const PaymentsRecordActions = (Data) => {
    return {
        type: 'PaymentsRecordActions',
        payload: Data
        
    }
}
export const EncounterMenuRecordActions = (Data) => {
    return {
        type: 'EncounterMenuRecordAction',
        payload: Data
        
    }
}
